<template>
  <div class="add-message-modal">
    <div class="div-block-45">
      <div>
        <div class="text-block-33">Send to:</div>
      </div>
      <div class="div-block-46">
        <form action="/search" class="search-4-copy w-form">
          <input
            type="search"
            class="search-input-3 w-input"
            maxlength="256"
            name="query"
            placeholder="Search…"
            id="search-3"
            required=""
            v-model="searchModel.stringToFind"
            @input="searchProfessionalAction"
          /><input
            type="submit"
            value="Search"
            class="search-button-2 w-button"
          />
        </form>
      </div>
      <div class="div-block-49" v-if="professionalList.length > 0">
        <div
          class="div-block-47 w-inline-block"
          v-for="(professional, index) in professionalList"
          :key="index"
          @click="profile(professional)"
        >
          <div class="div-block-48">
            <img
              :src="
                professional.customerDisplayPicture ||
                  require('@/assets/timeslot-images/profileImg.svg')
              "
              loading="lazy"
              width="50"
              height="50"
              alt=""
              style="border-radius: 50%;"
            />
          </div>
          <div>
            <div class="text-block-34">{{ professional.customerName }}</div>
            <div class="text-block-35">
              {{ professional.professionalSubCategory }}
            </div>
          </div>
        </div>
        <!--        <a href="#" class="div-block-47 w-inline-block">-->
        <!--          <div class="div-block-48">-->
        <!--            <img-->
        <!--              src="@/assets/timeslot-images/user.png"-->
        <!--              loading="lazy"-->
        <!--              width="50"-->
        <!--              alt=""-->
        <!--            />-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <div class="text-block-34">Idris Yusuf</div>-->
        <!--            <div class="text-block-35">Product Designer</div>-->
        <!--          </div>-->
        <!--        </a>-->
        <!--        <a href="#" class="div-block-47 w-inline-block">-->
        <!--          <div class="div-block-48">-->
        <!--            <img-->
        <!--              src="@/assets/timeslot-images/user.png"-->
        <!--              loading="lazy"-->
        <!--              width="50"-->
        <!--              alt=""-->
        <!--            />-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <div class="text-block-34">Idris Yusuf</div>-->
        <!--            <div class="text-block-35">Product Designer</div>-->
        <!--          </div>-->
        <!--        </a>-->
        <!--        <a href="#" class="div-block-47 w-inline-block">-->
        <!--          <div class="div-block-48">-->
        <!--            <img-->
        <!--              src="@/assets/timeslot-images/user.png"-->
        <!--              loading="lazy"-->
        <!--              width="50"-->
        <!--              alt=""-->
        <!--            />-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <div class="text-block-34">Idris Yusuf</div>-->
        <!--            <div class="text-block-35">Product Designer</div>-->
        <!--          </div>-->
        <!--        </a>-->
        <!--        <a href="#" class="div-block-47 w-inline-block">-->
        <!--          <div class="div-block-48">-->
        <!--            <img-->
        <!--              src="@/assets/timeslot-images/user.png"-->
        <!--              loading="lazy"-->
        <!--              width="50"-->
        <!--              alt=""-->
        <!--            />-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <div class="text-block-34">Idris Yusuf</div>-->
        <!--            <div class="text-block-35">Product Designer</div>-->
        <!--          </div>-->
        <!--        </a>-->
        <!--        <a href="#" class="div-block-47 w-inline-block">-->
        <!--          <div class="div-block-48">-->
        <!--            <img-->
        <!--              src="@/assets/timeslot-images/user.png"-->
        <!--              loading="lazy"-->
        <!--              width="50"-->
        <!--              alt=""-->
        <!--            />-->
        <!--          </div>-->
        <!--          <div>-->
        <!--            <div class="text-block-34">Idris Yusuf</div>-->
        <!--            <div class="text-block-35">Product Designer</div>-->
        <!--          </div>-->
        <!--        </a>-->
      </div>
      <div v-else style="text-align:center">
        <strong>No professionals in this search</strong>
      </div>
      <div
        data-w-id="a667988d-387e-117b-380c-c28d2f8d4b38"
        @click="cancel"
        class="link-block-5 w-inline-block"
      >
        <img src="@/assets/timeslot-images/cancel.svg" loading="lazy" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import ProfessionalRequest from "@/model/requests/ProfessionalRequest";

export default {
  name: "SendMessageModal",
  data() {
    return {
      searchModel: ProfessionalRequest.search
    };
  },
  props: {
    cancel: Function
  },
  computed: {
    ...mapState({
      professionalList: state => state.professional.professionalsDisplay
    })
  },
  methods: {
    profile(professional) {
      StoreUtils.commit(
        StoreUtils.mutations.professional.SET_PROFESSIONAL,
        professional
      );
      RouterUtils.changeRouteUrlTo(
        `/professionals/${professional.professionalId}`
      );
    },
    searchProfessionalAction() {
      StoreUtils.dispatch("professional/searchProfessional", this.searchModel);
    }
  },
  mounted() {
    StoreUtils.dispatch(StoreUtils.actions.professional.READ_PROFESSIONALS);
  }
};
</script>

<style scoped></style>
